import React from 'react';

import AlertAndConfirmation from '../../utils/AlertAndConfirmation';
import ENUMS from '../../enums';
import { permissionHelper } from '../../utils';

import styles from './styles.scss';

const { REPLY_COMMENT_BY_RSEE_USER, CONFIRM_OR_REJECT_COMMENT } = ENUMS.PERMISSIONS.values;
const { WAITING, CONFIRMED, REJECTED } = ENUMS.COMMENT_STATUS.values;

const CommentAdminButtons = props => {
  const confirmComment = () => {
    props
      .updateCommentStatus(props.id, CONFIRMED)
      .then(result => {
        AlertAndConfirmation({
          title: locales('titles.editionsDoneSuccessfully'),
          text: '',
          type: 'success'
        });
      })
      .catch(err => {
        AlertAndConfirmation({
          title: locales('messages.error.in.api.operation'),
          text: '',
          type: 'error',
          timer: 6000
        });
      });
  };

  const rejectComment = () => {
    props
      .updateCommentStatus(props.id, REJECTED)
      .then(result => {
        AlertAndConfirmation({
          title: locales('titles.editionsDoneSuccessfully'),
          text: '',
          type: 'success'
        });
      })
      .catch(err => {
        AlertAndConfirmation({
          title: locales('messages.error.in.api.operation'),
          text: '',
          type: 'error',
          timer: 6000
        });
      });
  };

  const toggleAllowCafeToReply = () => {
    props
      .changeCafeAccessStatusToResponse(props.id, !props.isCafeAllowedToRespond)
      .then(() => {
        AlertAndConfirmation({
          title: locales('titles.editionsDoneSuccessfully'),
          text: '',
          type: 'success'
        });
      })
      .catch(err => {
        AlertAndConfirmation({
          title: locales('messages.error.in.api.operation'),
          text: '',
          type: 'error',
          timer: 6000
        });
      });
  };

  let jsx = null;

  const confirmButtonJsx = (
    <button onClick={confirmComment} className={'btn btn-info ' + styles.commentBtn}>
      {locales('titles.acceptComment')}
    </button>
  );

  const rejectButtonJsx = (
    <button onClick={rejectComment} className={`btn btn-danger ` + styles.commentBtn}>
      {locales('titles.rejectComment')}
    </button>
  );

  const allowCafeButtonJsx = (
    <button
      onClick={toggleAllowCafeToReply}
      className={`btn btn-warning ` + styles.toggleAllowCafeBtn}
    >
      {props.isCafeAllowedToRespond
        ? locales('titles.disableCafeResponse')
        : locales('titles.allowCafeToResponse')}
    </button>
  );

  if (
    permissionHelper.hasUserPermission(REPLY_COMMENT_BY_RSEE_USER) ||
    permissionHelper.hasUserPermission(CONFIRM_OR_REJECT_COMMENT)
  ) {
    jsx = (
      <>
        {permissionHelper.hasUserPermission(CONFIRM_OR_REJECT_COMMENT) &&
          (props.status === WAITING || props.status === REJECTED) &&
          confirmButtonJsx}

        {permissionHelper.hasUserPermission(CONFIRM_OR_REJECT_COMMENT) &&
          (props.status === WAITING || props.status === CONFIRMED) &&
          rejectButtonJsx}

        {permissionHelper.hasUserPermission(REPLY_COMMENT_BY_RSEE_USER) &&
          props.status === CONFIRMED &&
          allowCafeButtonJsx}
      </>
    );
  }

  return jsx;
};

export default CommentAdminButtons;
